// extracted by mini-css-extract-plugin
export default {"container":"V0HtR","categories":"igsQL"};